import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { ITrip } from '@curbnturf/objects';
// cnt-landing's build file-replaces this shared file with its own environment.ts (see
// apps/cnt-landing/src/environments/shared-lib-environment.ts) specifically so lib code
// can read cnt-landing's own apiUrl, never curbnturf's. Plain const, no NgRx.
import { environment } from '@curbnturf/environment';
import { Observable } from 'rxjs';
import type { ITripPlan } from './trip-planner.service';
import { planToApiTrip } from './trip-backend-mapper';

/**
 * Real `/api/v1/route/trip` backend for trip plans. Plain `HttpClient` only —
 * no `CachedHttpClient`, no NgRx Facade — same pattern as
 * `ListingAddressGeocodingService` and this lib's own `RoutingService`. Auth
 * headers are attached automatically by the app-wide `jwtInterceptor`, which
 * matches on any request URL under `environment.apiUrl + '/api/v1/'`.
 */
@Injectable({ providedIn: 'root' })
export class TripBackendService {
  private http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/v1/route/trip`;

  /** Creates the trip if `plan.remoteId` is unset, otherwise updates it. */
  save$(plan: ITripPlan): Observable<ITrip> {
    const body = planToApiTrip(plan);
    return plan.remoteId
      ? this.http.put<ITrip>(`${this.base}/${plan.remoteId}`, body)
      : this.http.post<ITrip>(this.base, body);
  }

  get$(remoteId: number): Observable<ITrip> {
    return this.http.get<ITrip>(`${this.base}/${remoteId}`);
  }

  list$(): Observable<ITrip[]> {
    return this.http.get<ITrip[]>(this.base);
  }

  delete$(remoteId: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${remoteId}`);
  }
}
